export default __webpack_public_path__ + "static/media/case2-1 (2).ea9d3377.png";